import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions" }
const _hoisted_2 = ["disabled"]

interface Props {
  deletable: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'a-employee-timeblock-header-actions',
  props: {
    deletable: { type: Boolean, default: false }
  },
  emits: ["addTimeblock", "removeTimeblock"],
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "add-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addTimeblock')))
    }, "+"),
    _createElementVNode("button", {
      disabled: !props.deletable,
      class: "delete-btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('removeTimeblock')))
    }, " × ", 8, _hoisted_2)
  ]))
}
}

})